import React, { useState } from "react";
import "./DeleteModal.scss";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";

export default function DeleteModal(props) {
  const { REACT_APP_API_ENDPOINT } = process.env;
  const [show, setShow] = useState(true);

  const handleDelete = () => {
    axios
      .delete(REACT_APP_API_ENDPOINT + "/" + props.data.id)
      .then((res) => props.updateData());

    // setShow(false);
  };

  return (
    <>
      <Modal show={show} onHide={handleDelete}>
        <Modal.Header closeButton>
          <Modal.Title>Delete this listing?</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this listing?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            className="delete-modal__button"
            onClick={() => {
              props.closeDelete(false);
              setShow(!setShow);
            }}
          >
            Cancel
          </Button>
          <Button
            className="delete-modal__button"
            variant="secondary"
            onClick={handleDelete}
          >
            Yes, I do!
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
